import { render, staticRenderFns } from "./RoundedButton.vue?vue&type=template&id=0c02d4c6&"
import script from "./RoundedButton.vue?vue&type=script&lang=js&"
export * from "./RoundedButton.vue?vue&type=script&lang=js&"
import style0 from "./RoundedButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports